"use client";

import { IndustrialTemplateRuntime } from "./IndustrialTemplateRuntime";

export function TakeresRuntime({
    languageCode,
}: {
    languageCode?: string | null;
}) {
    return (
        <IndustrialTemplateRuntime
            languageCode={languageCode}
            templateCode="takeres"
        />
    );
}
